import {
  CreateNewPostContent,
  CreateNewPostContentV2,
} from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
`
export const StyledHeader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  padding: 18px;
  border-bottom: 1px solid #f3f3f3;
  background: white;
`
export const StyledHeading = styled.div`
  text-align: center;
  font-size: 18px;
  font-weight: 600;
`

export const StyledCloseBtn = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 67px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`
export const StyledBody = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 55px;
  bottom: 0;
  overflow-y: auto;
  padding: 10px 24px 24px;

  &[data-has-footer='true'] {
    bottom: 115px;
    &[data-is-login='true'] {
      bottom: 73px;
    }
  }
`
export const StyledFooter = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
`
export const StyledCreateNewPostContent = styled(CreateNewPostContent)`
  padding: 0;
`

export const StyledCreateNewPostContentV2 = styled(CreateNewPostContentV2)`
  padding: 0;
`

export const StyledBackBtn = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 67px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`
